import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { fadeInOutAnimation } from '../../../util/animations/fade-in-out.animation';
import { OrcaLogoComponent } from "../orca-logo-svg/orca-logo-svg.component";
import { AllIconsComponent } from "../../../domain/shared/component/all-icons/all-icons.component";
import { FRONT_URLS } from "../../../util/common/url-parts";
import { UnsavedChangesModalService } from "../../../domain/shared/component/unsaved-changes-modal-wrapper/service/unsaved-changes-modal.service";

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  animations: [fadeInOutAnimation(200, 50)],
  standalone: true,
  imports: [
    OrcaLogoComponent,
    AllIconsComponent,
  ],
})
export class SideNavComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private unsavedChangesService = inject(UnsavedChangesModalService);

  private _destroyStream: Subject<void> = new Subject<void>();
  protected readonly FRONT_URLS = FRONT_URLS;
  isDemo = false;


  ngOnInit(): void {
    this.initData();
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  async navigateToEntrance(): Promise<void> {
    const canProceed = await this.unsavedChangesService.checkCanProceed();
    if (!canProceed) {
      return;
    }
    await this.router.navigate([FRONT_URLS.ENTRANCE], { queryParamsHandling: 'preserve' });
  }

  private initData(): void {
    if (window.location.hostname.includes('demo')) {
      this.isDemo = true;
    }
  }
}

// Cannot move to the modal-stay component because then there is circular dependency.
// See (https://stackoverflow.com/questions/56870661/angular-7-2-1-es6-class-referenceerror-cannot-access-x-before-initializatio)
export const BROADCAST_CHANNEL_NAME = 'last_action_counter';
export const BROADCAST_CHANNEL_LOGOUT = 'logout';
export const BROADCAST_CHANNEL_LOGOUT_MESSAGE = 'logout';
